<template>
<div class="userList">
    <npHeader :param="param" @toggleTab="toggleTab" :flag="flag" :title="title"></npHeader>
    <div class="data-total">
        <div class="outbox box-shadow bgc">
            <div class="box">
                <div class="box-detail">
                    <div class="box-title">参与分销人数</div>
                    <div class="box-data"><span class="data">{{item.totalDisCount }}</span>人</div>
                </div>
            </div>
            <el-tooltip content="至少带来一个邀请人数的用户数 " placement="top">
                <div>
                    <i class="tip el-icon-info"></i>
                </div>
            </el-tooltip>
        </div>
        <div class="outbox box-shadow bgc">
            <div class="box">
                <div class="box-detail">
                    <div class="box-title">受邀总人数</div>
                    <div class="box-data"><span class="data">{{item.inviteCount}}</span>人</div>
                </div>
            </div>

            <el-tooltip content="当前活动所有参与者累计邀请的总人数" placement="top">
                <div>
                    <i class="tip el-icon-info"></i>
                </div>
            </el-tooltip>
        </div>
        <div class="outbox box-shadow bgc">
            <div class="box">
                <div class="box-detail">
                    <div class="box-title">分销出单人数</div>
                    <div class="box-data"><span class="data">{{item.successordercount }}</span>人</div>
                </div>
            </div>

            <el-tooltip content="该活动中至少收到了一笔返现的人数" placement="top">
                <div>
                    <i class="tip el-icon-info"></i>
                </div>
            </el-tooltip>
        </div>
        <div class="outbox box-shadow bgc">
            <div class="box">
                <div class="box-detail">
                    <div class="box-title">分销订单总数</div>
                    <div class="box-data"><span class="data">{{item.totalordercount }}</span>笔</div>
                </div>
            </div>
            <el-tooltip content="当前活动用户累计所有用户分销的订单总数" placement="top">
                <div>
                    <i class="tip el-icon-info"></i>
                </div>
            </el-tooltip>
        </div>
    </div>
    <div class="filters padding-20 bgc">
        <div class="add">
            <el-button v-if="permission.btnList.indexOf('A09')==-1" type="success" @click="handleExport">导出excel</el-button>
        </div>
        <div class="search">
            <div>
                <!--<span>是否队长&nbsp;&nbsp;</span>-->
                <el-select v-model="param.isheader" placeholder="是否队长" class="condition" clearable>
                    <el-option v-for="item in isheaderList" :key="item.code" :label="item.name" :value="item.code"> </el-option>
                </el-select>
            </div>
            <div class="search-input">
                <!--<span>用户昵称&nbsp;&nbsp;</span>-->
                <el-input v-model="param.keywords" placeholder="请输入用户昵称" class="condition" clearable></el-input>
                <el-input v-model="param.chname" placeholder="请输入渠道名称" class="condition" clearable></el-input>
            </div>
            <el-button type="primary" plain @click="handleQuery">搜索</el-button>
        </div>
    </div>
    <div class="result-list btn-operate-list padding-20 bgc">
        <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="customername" label="用户昵称" width="200px">
                <template slot-scope="scope">
                    <div class="imageText">
                        <img v-lazy="scope.row.customericonurl" :alt="scope.row.subject" preview="videoList">
                        <div class="imageText-summary">
                            <div>{{scope.row.customername}}</div>
                            <div class="icon_header" v-if="scope.row.iseventheader"></div>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="直接上级" class-name="center">
                <template slot-scope="scope">
                    <span>{{scope.row.parentusername ? scope.row.parentusername : '--'}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="invitecount" label="邀请人数" class-name="center"></el-table-column>
            <!--<el-table-column prop="firstordermoney" label="直接订单额" class-name="center"></el-table-column>-->
            <!--<el-table-column prop="secondordermoney" label="间接订单额" class-name="center"></el-table-column>-->
            <el-table-column prop="totalordercount" label="分销订单" class-name="center"></el-table-column>
            <el-table-column prop="totalbrokerage" label="分销奖励" class-name="center">
                <template slot-scope="scope">￥{{scope.row.totalbrokerage}}</template>
            </el-table-column>
            <el-table-column prop="eventheaderordercount" label="队长订单" class-name="center"></el-table-column>
            <el-table-column prop="eventheaderbrokerage" label="队长奖励" class-name="center">
                <template slot-scope="scope">{{scope.row.iseventheader? '￥':''}}{{scope.row.eventheaderbrokerage}}</template>
            </el-table-column>
            <el-table-column prop="chname" label="渠道名称" class-name="center" min-width="80"></el-table-column>
            <el-table-column label="操作" width="240" label-class-name="tr">
                <template slot-scope="scope">
                    <div class="tr">
                        <span class="separator-btn" v-if="item.isopeneventheader&&!scope.row.iseventheader">
                            <el-button @click="handleHeaderAdd(scope.row)" size="small" type="primary">设为队长</el-button>
                        </span>
                        <span class="separator-btn" v-if="item.isopeneventheader &&scope.row.isupdateeventheader&&scope.row.iseventheader">
                            <el-button @click="handleHeaderEdit(scope.row)" size="small" type="primary" >编辑队长</el-button>
                        </span>
                        <span class="separator-btn" v-if="item.isopeneventheader && scope.row.iseventheader">
                            <el-button @click="handleOrderListByEventHeader(scope.row)" size="small" type="primary">队长订单</el-button>
                        </span>
                        <span class="separator-btn">
                            <el-dropdown>
                            <span class="el-dropdown-link tr">
                                <el-button type="text" size="small">更多设置</el-button>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item @click.native="handleOrderListByDisUser(scope.row)" type="text" size="small">分销订单</el-dropdown-item>
                                <el-dropdown-item @click.native="handleHeaderQuery(scope.row)" type="text" size="small" v-if="item.isopeneventheader&&scope.row.iseventheader">查看队长</el-dropdown-item>
                                <el-dropdown-item @click.native="handleSetWriter(scope.row)" type="text" size="small" v-if="!scope.row.ischeckuser">设为核销员</el-dropdown-item>
                                <el-dropdown-item @click.native="handleCancelWriter(scope.row)" type="text" size="small" v-if="scope.row.ischeckuser">取消核销员</el-dropdown-item>
                            </el-dropdown-menu>
                            </el-dropdown>
                        </span>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <div class="page">
            <el-pagination background
                           @current-change="_getList"
                           :current-page.sync="page.page"
                           :page-size="page.pageSize"
                           :pager-count="11"
                           layout="prev, pager, next"
                           :total="total">
            </el-pagination>
        </div>
    </div>
    <popHeaderEdit ref="popHeaderEdit" @getList="_getList"></popHeaderEdit>
    <popOrderList ref="popOrderList"></popOrderList>
    <popHeaderOrderList ref="popHeaderOrderList"></popHeaderOrderList>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {getUserInfoList, getStatisticsUserInfo, exportUserList, setWriter} from 'api/nationalDistribution'
import {dateFormat} from 'common/js/tools'
import {nationalDistribution as nationalDistributionCode} from 'api/enumCode'
import {nationalDistribution} from 'api/message'
import PopHeaderEdit from 'views/tools/nationalDistribution/user/components/popHeaderEdit.vue'
import PopOrderList from 'views/tools/nationalDistribution/user/components/popOrderList.vue'
import PopHeaderOrderList from 'views/tools/nationalDistribution/user/components/popHeaderOrderList.vue'
import NpHeader from 'views/tools/nationalDistribution/components/npHeader.vue'
export default {
    name: 'userList',
    data() {
        return {
            tableData: [],
            title: '用户管理',
            isheaderList: nationalDistributionCode.isheader,
            item: {
                inviteCount: 0,
                isopeneventheader: 0, // 是否开通队长
                successordercount: 0,
                totalDisCount: 0,
                totalordercount: 0
            },
            total: 0,
            power: {},
            page: {
                page: 1,
                pageSize: 10
            }
        }
    },
    props: ['param', 'flag'],
    mounted() {
        this.power = this.permission.btnObj.A09 ? this.permission.btnObj.A09 : []
    },
    methods: {
        toggleTab() {
            this.param.keywords = ''
            this.setParams(this._.cloneDeep(this.param))
            this._getStatisticsUserInfo()
        },
        handleOrderListByDisUser(obj) {
            this.$refs.popOrderList.open(obj)
        },
        handleOrderListByEventHeader(obj) {
            this.$refs.popHeaderOrderList.open(obj)
        },
        handleHeaderQuery(obj) {
            this.$refs.popHeaderEdit.open(obj, 1)
        },
        handleHeaderAdd(obj) {
            this.$refs.popHeaderEdit.open(obj, 2)
        },
        handleHeaderEdit(obj) {
            this.$refs.popHeaderEdit.open(obj, 3)
        },
        handleIncomesetting(row) {
            this.$router.push({name: 'NDUserIncomesetting', query: {id: row.innerid}})
        },
        handleExport() {
            this.setLoading(true)
            exportUserList({
                data: this.param,
                success: data => {
                    let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                    let fileName = '用户名单' + dateFormat(new Date()) + '.xls'
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName)
                    } else {
                        var link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = fileName
                        link.click() // 释放内存
                        window.URL.revokeObjectURL(link.href)
                    }
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        handleSetWriter(row) {
            let status = 1
            this.$confirm(nationalDistribution.setWriter.msg, nationalDistribution.setWriter.title, {
                confirmButtonText: nationalDistribution.setWriter.confirmText,
                cancelButtonText: nationalDistribution.setWriter.cancelText
            }).then(() => {
                this._setWriter(row, status, nationalDistribution.setWriter.successMsg)
            }).catch(() => {})
        },
        handleCancelWriter(row) {
            let status = 0
            this.$confirm(nationalDistribution.cancelWriter.msg, nationalDistribution.cancelWriter.title, {
                confirmButtonText: nationalDistribution.cancelWriter.confirmText,
                cancelButtonText: nationalDistribution.cancelWriter.cancelText
            }).then(() => {
                this._setWriter(row, status, nationalDistribution.cancelWriter.successMsg)
            }).catch(() => {})
        },
        handleQuery() {
            this.setParams(this._.cloneDeep(this.param))
            this.page.page = 1
            this._getList()
        },
        handleAdd() {
            this.$router.push({name: 'NDWithdrawalEdit'})
        },
        _setWriter(obj, ischeckuser, tip) {
            this.setLoading(true)
            setWriter({
                data: {
                    eventinnerid: obj.eventinnerid,
                    userinnerid: obj.innerid,
                    ischeckuser: ischeckuser
                },
                success: data => {
                    this.$message.success(tip)
                    this.setLoading(false)
                    this._getList()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getStatisticsUserInfo() {
            this.setLoading(true)
            getStatisticsUserInfo({
                data: Object.assign({}, {eventinnerid: this.param.eventinnerid}, this.page),
                success: data => {
                    this.item = data.data
                    this.setLoading(false)
                    this._getList()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getList() {
            this.setLoading(true)
            getUserInfoList({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    this.tableData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading',
            'setParams'
        ])
    },
    filters: {
        status: function (value) {
            return value
        }
    },
    watch: {},
    computed: {
        ...mapGetters([
            'user',
            'permission',
            'params'
        ])
    },
    components: {
        PopHeaderEdit, PopOrderList, PopHeaderOrderList, NpHeader
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/index";
.userList {
    .data-total {
        margin-top: 24px;
        @include flexBox(space-between);
        .outbox {
            padding: 30px;
            height: 100px;
            box-sizing: border-box;
            position: relative;
            flex-grow: 1;
            flex-basis: 200px;
            .box {
            }
            .el-tooltip {
                position: absolute;
                width: 14px;
                height: 14px;
                top: 10px;
                right: 10px;
            }
        }
        .outbox + .outbox {
            margin-left: 40px;
        }
    }
    .filters {
        margin-top: 24px;
        margin-bottom: 0;
        padding: 20px 20px 10px 20px;
        .search{
            flex-grow: 1;
            .search-input{
                .el-input{
                    width: 240px;
                }
            }
        }
    }
    .center {
        .cell {
            text-align: center;
        }
    }
    .imageText {
        .imageText-summary{
            display: flex;
            align-items: center;
            line-height: 20px;
            box-sizing: border-box;
            .icon_header{
                height: 20px;
                width: 20px;
                margin-left: 6px;
                &:before{
                    width: 100%;
                    height: 100%;
                }
            }
            div:nth-child(1){
                margin-bottom: 0;
            }
        }
        img {
            width: 50px;
            min-width: 50px;
            max-width: 50px;
            height: 50px;
            border-radius: 50%;
        }
    }
    .btn-operate-list .el-button--primary{
        width: 60px;
        height: 24px;
        text-align: center;
        line-height: 24px;
    }
}
.pop-np-user{
    .title{
        display: flex;
        align-items: center;
        justify-content: flex-start;
        font-size: 14px;
        margin-bottom: 20px;
        .box{
            display: flex;
            align-items: center;
            margin-right: 30px;
            .img{
                width: 50px;
                height: 50px;
                border-radius: 50%;
                margin-left: 10px;
            }
        }
    }
    .imgtext{
        display: flex;
        align-items: center;
        .img{
            width: 50px;
            height: 50px;
            border-radius: 50%;
            margin-right: 10px;
        }
    }
}
</style>
